import Popups from '@/component/popups';
import frameshweVaultImg from '@assets/web-v3-images/frame-shweVault.png';
import imgExplorerBadge from '@assets/web-v3-images/icons/badge-explorer.png';
import imgMasterBadge from '@assets/web-v3-images/icons/badge-master.png';
import imgExit from '@assets/web-v3-images/icons/exits.png';
import { useTranslation } from 'react-i18next';

const Rows = ({ titleRow }) => {
	return <p className="text-[13px] sm:text-[20px] font-bold text-[rgba(84,35,20,1)] text-center">{titleRow}</p>
}

export default function RankComparison({ open, onOpenChange }) {
	const { t } = useTranslation()

	const data = [
		{ vault: "shwe_vault.Vault_I", pieces: "shwe_vault.500_pieces", explorer: "1,000 LP", master: "1,500 LP" },
		{ vault: "shwe_vault.Vault_II", pieces: "shwe_vault.1,000_pieces", explorer: "2,500 LP", master: "3,500 LP" },
		{ vault: "shwe_vault.Vault_III", pieces: "shwe_vault.2,000_pieces", explorer: "4,000 LP", master: "5,500 LP" },
		{ vault: "shwe_vault.Vault_IV", pieces: "shwe_vault.5,000_pieces", explorer: "7,500 LP", master: "9,500 LP" },
	]

	return (
		<Popups
			open={open}
			onOpenChange={onOpenChange}
			className="!bg-transparent !shadow-none !p-0"
		>
			<div className='mx-[2%]'>
				<div className="flex flex-col w-full relative">
					<img
						className="w-[10%] h-auto absolute top-0 right-[7px] btn-click-active z-10"
						src={imgExit}
						onClick={() => onOpenChange(false)}
						alt=""
					/>
					<div
						className="relative z-2 -mt-0.5 w-full"
						style={{
							backgroundImage: `url(${frameshweVaultImg})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "100% 100%",
							backgroundPosition: "center",
						}}
					>
						<div className="">
							<p className='absolute left-1/2 top-6 sm:top-8 -translate-x-1/2 -translate-y-1/2 text-[rgba(122,46,14,1)] 
							text-[13px] sm:text-[25px] font-bold whitespace-nowrap'>
								{t("shwe_vault.rank_benefits_comparison")}
							</p>
							<div className="w-full px-[1.5%] pb-1.5 sm:pb-3">
								<div className="grid grid-cols-[1fr_1fr_1fr] items-end  pt-5 pb-3 bg-[#FFDFB0]/60 rounded-tl-[20px] rounded-tr-[20px] mt-7 sm:mt-13 pt-8">
									<div />
									<div className="flex flex-col items-center gap-1">
										<Rows titleRow={t("shwe_vault.shwe_explorer")} />
										<img src={imgExplorerBadge} className="w-10 sm:w-20" alt="" />
									</div>

									<div className="flex flex-col items-center gap-1">
										<Rows titleRow={t("shwe_vault.shwe_master")} />
										<img src={imgMasterBadge} className="w-10 sm:w-20" alt="" />
									</div>
								</div>
								{data?.map((row, i) => (
									<div
										key={row.vault}
										className={`grid grid-cols-[1fr_1fr_1fr] items-center py-1.5 sm:py-3 ${i % 2 === 0 ? "bg-transparent" : "bg-[#FFDFB0]/60 rounded-bl-[20px] rounded-br-[20px]"
											}`}
									>
										<div className="text-left">
											<Rows titleRow={t(row.vault)} />
											<Rows titleRow={"(" + t(row.pieces) + ")"} />
										</div>
										<Rows titleRow={row.explorer} />
										<Rows titleRow={row.master} />
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</Popups>
	)
}
